function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertSlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.52 491.52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M487.655,396.138c-39.56-51.54-61.34-114.979-61.34-180.663v-55.109 c0-66.52-51.119-123.758-117.566-126.887c-70.941-3.342-129.509,53.188-129.509,123.397v58.599 c0,65.684-21.781,129.123-61.34,180.663c-9.162,11.934-1.054,29.145,13.99,29.145h341.775 C488.708,425.283,496.815,408.072,487.655,396.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M291.94,69.168c54.343,0,98.55,44.208,98.55,98.543v58.598c0,62.656,17.805,122.57,50.988,173.984 h18.127c-37.869-53.742-58.28-117.711-58.28-184.818v-58.599c0-54.336-44.208-98.544-98.552-98.544 c-29.919,0-56.718,13.45-74.804,34.568C245.203,78.142,267.525,69.168,291.94,69.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8744"
    },
    d: "M236.54,425.284c0,36.581,29.655,66.236,66.236,66.236c36.582,0,66.236-29.656,66.236-66.236H236.54z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M139.944,0C62.654,0,0,62.654,0,139.943c0,77.288,62.653,139.944,139.943,139.944 c77.288,0,139.944-62.656,139.944-139.944C279.888,62.654,217.232,0,139.944,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M139.944,24.679c-63.659,0-115.264,51.606-115.264,115.264s51.606,115.264,115.264,115.264 c63.658,0,115.264-51.606,115.264-115.264S203.602,24.679,139.944,24.679z M139.944,251.478 c-61.599,0-111.534-49.935-111.534-111.535c0-61.599,49.935-111.534,111.534-111.534s111.534,49.935,111.534,111.534 C251.478,201.543,201.543,251.478,139.944,251.478z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBF0F3"
    },
    cx: 139.945,
    cy: 139.945,
    r: 111.534
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E56353"
    },
    cx: 239.206,
    cy: 139.945,
    r: 5.192
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E56353"
    },
    cx: 139.945,
    cy: 40.683,
    r: 5.192
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E56353"
    },
    cx: 139.945,
    cy: 239.206,
    r: 5.192
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E56353"
    },
    cx: 40.683,
    cy: 139.945,
    r: 5.192
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M199.878,139.943l-2.22-2.626l-44.272-1.181c0.346,1.22,0.591,2.479,0.591,3.807 c0,1.329-0.245,2.588-0.591,3.806l44.272-1.18L199.878,139.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F4859"
    },
    d: "M153.387,136.136l-9.414-0.251v8.115l9.414-0.251c0.346-1.218,0.591-2.478,0.591-3.806 C153.978,138.615,153.733,137.356,153.387,136.136z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#64798A"
    },
    points: "144.433,133.155 135.452,133.155 137.316,63.211 139.943,60.991 142.569,63.211  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 139.945,
    cy: 139.945,
    r: 8.945
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E56353"
    },
    points: "135.89,145.847 212.617,69.119 210.818,67.321 134.091,144.048 133.191,143.148  113.418,162.922 117.016,166.52 136.789,146.746 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A556A"
    },
    cx: 139.945,
    cy: 139.945,
    r: 5.192
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertSlow);
export default __webpack_public_path__ + "static/media/IconAlertSlow.8a594f54d606e95d31824438c2565b6f.svg";
export { ForwardRef as ReactComponent };